type SidebarUrlListener = () => void

const listeners = new Set<SidebarUrlListener>()
let historyPatched = false

export const SIDEBAR_DRAWER_WIDTH = 400

function notifySidebarUrlChange() {
  listeners.forEach(listener => listener())
}

function patchHistoryOnce() {
  if (historyPatched) return
  historyPatched = true

  const originalPushState = window.history.pushState.bind(window.history)
  const originalReplaceState = window.history.replaceState.bind(window.history)

  window.history.pushState = function (...args) {
    originalPushState(...args)
    notifySidebarUrlChange()
  }

  window.history.replaceState = function (...args) {
    originalReplaceState(...args)
    notifySidebarUrlChange()
  }

  window.addEventListener('popstate', notifySidebarUrlChange)
}

export function subscribeSidebarUrlChange(listener: SidebarUrlListener): () => void {
  patchHistoryOnce()
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function getSidebarParam(name: string): string | null {
  return new URLSearchParams(window.location.search).get(name)
}

export function isAnySidebarOpen(): boolean {
  const params = new URLSearchParams(window.location.search)
  return params.has('history') || params.has('comments')
}

export const openEventComments = (eventId: number) => {
  const params = new URLSearchParams(window.location.search)
  params.delete('history')
  params.set('comments', eventId.toString())
  window.history.pushState({}, '', `${window.location.pathname}?${params}`)
}

export const openVersionHistory = (eventId: number) => {
  const params = new URLSearchParams(window.location.search)
  params.delete('comments')
  params.set('history', eventId.toString())
  window.history.pushState({}, '', `${window.location.pathname}?${params}`)
}

export const closeSidebarParam = (name: string) => {
  const params = new URLSearchParams(window.location.search)
  params.delete(name)
  const query = params.toString()
  window.history.replaceState(
    {},
    '',
    `${window.location.pathname}${query ? `?${query}` : ''}`
  )
}

export const EVENT_COMMENTS_UPDATED = 'eventCommentsUpdated'

export function notifyEventCommentsUpdated(eventId: number) {
  window.dispatchEvent(
    new CustomEvent(EVENT_COMMENTS_UPDATED, { detail: { eventId } })
  )
}
